<div class="ap-navigation-wrapper">
    <ap-navigation [(selectedIndex)]="selectedIndex" [navList]="navList" [solid]="true" [width]="biggerWidth ? '20rem' : '230px'" 
        [hasHeader]="false" [collapsed]="collapse" (onClick)="redirect($event.item,scroll)" (onCollapsedItems)="onCollapsedItems($event)">
    </ap-navigation>
</div>